import "./BottomBar.css";

const BottomBar = ({ className = "" }) => {
  return (
    <div className={`newsletter_section ${className}`}>
      <div className="newsletter_container">
        <div className="newsletter_title_box">
          <h4>Subscribe to our Newsletter</h4>
          <span>to get emails regarding latest offers and discounts</span>
        </div>
        <div className="newsletter_input_group">
          <input type="email" placeholder="Enter your email" />
          <button type="button">Subscribe</button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
